<template>

    <section
      :key="componentKey"
    >

    <b-row v-if="loading">

      <b-col v-if="loading" sm="12" md="12" lg="12" xl="12" align="center" style="min-height: calc(var(--vh, 1vh) * 80);display: flex;">
            <div style="margin: auto;text-align: center;">
              
            <img

            alt="Cargando"
            width="50px"
            src="/img/loading.svg"
            >

            <p style="font-size: 16px; font-weight: bold;">
            Comprobando usuario
            </p>

            </div>
            
        </b-col>


    </b-row>

    <b-row v-else>

    

      <b-tabs
       class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
       vertical
       content-class="col-12 col-sm-12 col-md-8 col-lg-10 col-xl-10 mt-1 mt-md-0"
       pills
       nav-wrapper-class="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2 card_admin"
       nav-class="nav-left "
       v-model="activoPanel"
     >


     <b-tab  @click="EstadisticasLoad">

          <template #title>
            <feather-icon
            icon="ActivityIcon"
            size="15"

            class="margin-icon-profile"
            />

            <span class=" d-none d-sm-none d-md-block d-lg-block d-xl-block">Estadísticas</span>
            <span class="titulo_menu d-block d-sm-block d-md-none d-lg-none d-xl-none">Estadísticas</span>


          </template>

         

          <estadisticas v-if="ifEstadisticas" :key="componentKeyEstadisticas"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


        

          </b-tab>

       <b-tab  @click="RetirosLoad">

         <template #title>
            <feather-icon
            icon="UserIcon"
            size="15"

            class="margin-icon-profile"
            />

            <span class="titulo_menu" >Retiros de dinero <count-retiros :key="componentKeyCountRetiros" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  />  </span>

 


         </template>

         <b-card>

          <retiros v-if="ifRetiros" :key="componentKeyRetiros"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />
        

         </b-card>

       </b-tab>

       <b-tab  @click="RemesasLoad">

            <template #title>

                <svg style="    width: 20px;" width="15" class="icons_colors margin-icon-profile" height="15" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 945.5 945.5" ><g><g><path d="M255.1 457.399c126.3.0 228.7-102.399 228.7-228.7C483.799 102.4 381.4.0 255.1.0 128.8.0 26.4 102.4 26.4 228.7 26.4 355 128.8 457.399 255.1 457.399zM160.7 124.5c0-12.4 10.1-22.5 22.5-22.5h50V71.7c0-12.4 10.1-22.5 22.5-22.5s22.5 10.1 22.5 22.5v30.4h43.5c12.4.0 22.5 10.1 22.5 22.5.0 12.4-10.1 22.5-22.5 22.5h-43.4v59.1h47.8c12.399.0 22.5 10.1 22.5 22.5v104.1c0 12.4-10.101 22.5-22.5 22.5h-47.8v30.4c0 12.399-10.1 22.5-22.5 22.5s-22.5-10.101-22.5-22.5v-30.4h-47.7c-12.4.0-22.5-10.1-22.5-22.5s10.1-22.5 22.5-22.5h47.7v-59.1h-50c-12.4.0-22.5-10.1-22.5-22.5V124.5H160.7z"/><path d="M205.7 147h27.5v59.1H205.7z"/><path d="M278.2 251.2h25.3v59.1H278.2z"/><path d="M919.1 716.8c0-126.3-102.4-228.7-228.7-228.7S461.6 590.5 461.6 716.8 564 945.5 690.299 945.5C816.6 945.5 919.1 843.1 919.1 716.8zM786.2 648.3c0 12.4-10.1 22.5-22.5 22.5s-22.5-10.1-22.5-22.5v-15.9h-97.8V660.2h46.3c12.4.0 22.5 10.1 22.5 22.5.0 12.399-10.1 22.5-22.5 22.5h-46.3v17.6h46.3c12.4.0 22.5 10.1 22.5 22.5s-10.2 22.5-22.6 22.5h-46.301v27.9H741.1v-15.2c0-12.4 10.1-22.5 22.5-22.5 12.399.0 22.5 10.1 22.5 22.5v37.7c0 12.399-10.101 22.5-22.5 22.5H620.799c-12.399.0-22.5-10.101-22.5-22.5v-50.4h-14.8c-12.399.0-22.5-10.1-22.5-22.5s10.101-22.5 22.5-22.5h14.8v-17.6h-14.8c-12.399.0-22.5-10.101-22.5-22.5.0-12.4 10.101-22.5 22.5-22.5h14.8v-50.301c0-12.399 10.101-22.5 22.5-22.5h142.9c12.4.0 22.5 10.101 22.5 22.5V648.3z"/><path d="M639.4 391.399l42.7 61.9c4 5.8 12.5 5.8 16.5.0l42.699-61.9c4.601-6.6-.199-15.7-8.199-15.7h-12.5c-3.7-38.3-13.301-72.1-28.601-100.8-16.8-31.6-40.2-57-69.7-75.5-32.899-20.6-65.899-27.8-85.1-30.3-8.9-1.2-16.8 5.8-16.9 14.8l-.1 30.3c0 7.4 5.4 13.7 12.7 14.9 13.8 2.1 37 7.7 59.5 22.4 38.399 25 61.1 66.7 67.8 124.2h-12.5C639.6 375.7 634.9 384.7 639.4 391.399z"/><path d="M209.3 578.3h12.5c3.7 38.3 13.3 72.1 28.6 100.8 16.8 31.601 40.2 57 69.7 75.5 32.899 20.601 65.899 27.8 85.1 30.3 8.9 1.2 16.8-5.8 16.9-14.8l.1-30.3c0-7.4-5.4-13.7-12.7-14.9C395.6 722.8 372.4 717.2 350 702.5c-38.399-25-61.1-66.7-67.8-124.2h12.5c8.1.0 12.8-9 8.2-15.7l-42.7-61.8c-4-5.8-12.5-5.8-16.5.0L201 562.7C196.5 569.3 201.2 578.3 209.3 578.3z"/></g></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>

                <span class="titulo_menu" >Envios de remesas <count-remesas :key="componentKeyCountRemesas" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  />  </span>


            </template>

       <b-row>


        <b-col  cols="12" sm="12" md="12" xl="12" lg="12"  >

          <remesas v-if="ifRemesas" :key="componentKeyRemesas"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


          </b-col>





       </b-row>


            </b-tab>

            <b-tab  @click="PaypalLoad">

              <template #title>

              
                  <svg  style="    width: 20px;" width="15" class="icons_colors margin-icon-profile" height="15"  viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg"><title>PayPal icon</title><path d="M6.908 24H3.804c-.664.0-1.086-.529-.936-1.18l.149-.674h2.071c.666.0 1.336-.533 1.482-1.182l1.064-4.592c.15-.648.816-1.18 1.48-1.18h.883c3.789.0 6.734-.779 8.84-2.34s3.16-3.6 3.16-6.135c0-1.125-.195-2.055-.588-2.789.0-.016-.016-.031-.016-.046l.135.075c.75.465 1.32 1.064 1.711 1.814.404.75.598 1.68.598 2.791.0 2.535-1.049 4.574-3.164 6.135-2.1 1.545-5.055 2.324-8.834 2.324h-.9c-.66.0-1.334.525-1.484 1.186L8.39 22.812c-.149.645-.81 1.17-1.47 1.17L6.908 24zm-2.677-2.695H1.126c-.663.0-1.084-.529-.936-1.18L4.563 1.182C4.714.529 5.378.0 6.044.0h6.465c1.395.0 2.609.098 3.648.289 1.035.189 1.92.519 2.684.99.736.465 1.322 1.072 1.697 1.818.389.748.584 1.68.584 2.797.0 2.535-1.051 4.574-3.164 6.119-2.1 1.561-5.056 2.326-8.836 2.326h-.883c-.66.0-1.328.524-1.478 1.169L5.7 20.097c-.149.646-.817 1.172-1.485 1.172l.016.036zm7.446-17.369h-1.014c-.666.0-1.332.529-1.48 1.178l-.93 4.02c-.15.648.27 1.179.93 1.179h.766c1.664.0 2.97-.343 3.9-1.021.929-.686 1.395-1.654 1.395-2.912.0-.83-.301-1.445-.9-1.84-.6-.404-1.5-.605-2.686-.605l.019.001z"/></svg>

                  <span class="titulo_menu" >PayPal <count-paypal :key="componentKeyCountPaypal" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  />  </span>


              </template>

              <b-card>

              <paypal v-if="ifPaypal" :key="componentKeyPaypal"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


              </b-card>


              </b-tab>

              <b-tab  @click="WesterLoad">

              <template #title>

                <svg style="    width: 20px;" width="15" class="icons_colors margin-icon-profile" height="15"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 612.006 612.006"><g><g><path d="M482.288 437.042c-45.521.0-82.42 36.899-82.42 82.426.0 45.514 36.906 82.414 82.42 82.414 45.521.0 82.414-36.899 82.414-82.414C564.702 473.947 527.809 437.042 482.288 437.042zM482.288 583.58c-35.412.0-64.112-28.7-64.112-64.112.0-35.412 28.7-64.118 64.112-64.118 35.406.0 64.118 28.707 64.118 64.118C546.407 554.88 517.694 583.58 482.288 583.58z"/><path d="M0 262.212h126.044V10.124H0V262.212zM62.385 36.234c18.547.0 33.578 15.05 33.578 33.584.0 18.541-15.031 33.578-33.578 33.578-18.541.0-33.578-15.037-33.578-33.578C28.807 51.284 43.838 36.234 62.385 36.234z"/><path d="M465.55 355.825c0 0-3.372 19.934 10.859 24.352.0.0 15.157 2.836 19.039-10.821l5.691-83.454c.592-8.363-3.933-14.942-3.933-14.942-1.683-2.445-3.655-4.878-5.729-7.266-7.72-3.775-17.192-8.124-28.089-12.567 1.33 1.733 2.653 3.561 3.901 5.451.0.0 5.489 9.346 4.487 18.447L465.55 355.825z"/><path d="M524.437 397.155c0 0 5.199.945 11.092-.851 1.947-23.406 6.075-69.406 9.983-90.411.0.0 3.183-17.602-16.297-28.618.0.0-9.806-5.943-26.81-14.01 2.597 2.83 5.048 5.779 7.096 8.729.0.0 4.752 6.794 4.134 15.428l-6.101 87.834C507.535 375.261 507.39 394.47 524.437 397.155z"/><path d="M573.141 202.493C440.177 81.333 329.933 49.627 329.933 49.627c-24.982-7.273-59.014-7.985-59.014-7.985H157.555V180.29h50.689c53.499 119.742 135.062 183.224 135.062 183.224 23.999 18.881 54.684 45.256 54.684 45.256 21.642 19.675 29.501 17.98 29.501 17.98 17.318.0 16.789-21.698 16.789-21.698.0-39.332-62.94-104.478-62.94-104.478-11.804-13.644-.265-29.948-.265-29.948 19.94-24.913 41.311-34.517 41.311-34.517 8.458-4.714 27.144-.794 27.144-.794 55.863 10.626 97.041 38.683 97.041 38.683 12.85 8.13 11.602 25.688 11.602 25.688-3.542 21.245-8.521 76.799-8.521 76.799-2.54 32.267 15.535 34.278 15.535 34.278 45.439 5.275 46.819-129.428 46.819-129.428C612 231.754 573.141 202.493 573.141 202.493z"/><path d="M508.014 519.827c-2.672-1.739-5.697-3.057-9.081-3.964-3.384-.907-6.813-1.639-10.279-2.193v-18.32c7.317.328 15.22 1.872 23.703 4.62v-16.342c-3.479-1.21-7.279-2.162-11.439-2.855-4.153-.681-8.243-1.147-12.258-1.361v-8.256h-13.127v8.508c-4.449.492-8.464 1.374-12.006 2.647-3.548 1.26-6.561 2.924-9.037 4.985-2.477 2.073-4.38 4.512-5.697 7.355-1.323 2.836-1.985 6.069-1.985 9.699.0 4.456.851 8.092 2.565 10.903 1.702 2.798 3.926 5.061 6.649 6.768 2.723 1.708 5.792 2.987 9.201 3.838 3.416.851 6.85 1.525 10.317 2.01v18.094c-2.798-.063-5.388-.214-7.752-.46-2.37-.246-4.626-.58-6.775-.989-2.136-.416-4.235-.908-6.277-1.494-2.023-.574-4.115-1.242-6.271-2.017v16.184c3.145 1.431 7.09 2.534 11.854 3.334 4.764.807 9.838 1.286 15.226 1.45v8.086h13.127v-8.502c9.081-.989 16.083-3.491 21.012-7.506 4.922-4.015 7.386-9.554 7.386-16.6.0-4.405-.838-8.004-2.515-10.815C512.86 523.829 510.68 521.56 508.014 519.827zM475.526 511.609c-3.573-.655-6.239-1.601-8.01-2.811-1.752-1.21-2.634-2.975-2.634-5.281.0-2.029.769-3.725 2.307-5.073 1.544-1.355 4.33-2.244 8.331-2.685v15.85H475.526zM488.653 545.376v-15.522c3.466.611 6.05 1.506 7.72 2.685 1.683 1.185 2.515 2.93 2.515 5.237C498.888 541.961 495.479 544.488 488.653 545.376z"/></g></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>
        
                <span class="titulo_menu" >Red Activa / Wester U. <count-wester :key="componentKeyCountWester" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  />  </span>


              </template>

              <b-card>

              <wester v-if="ifWester" :key="componentKeyRecargas"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


              </b-card>


              </b-tab>


              <b-tab  @click="DepositosLoad">

              <template #title>
                <feather-icon
                icon="HomeIcon"
                size="15"

                class="margin-icon-profile"
                />
                <span class="titulo_menu" >Transferencias Banc. <count-transferencias :key="componentKeyCountTransferencias" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  />  </span>

      

              </template>

              <b-card>

              <depositos v-if="ifDepositos" :key="componentKeyDepositos"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


              </b-card>

              </b-tab>

              <b-tab  @click="UsersLoad">

              <template #title>
                <feather-icon
                  icon="UsersIcon"
                  size="15"

                  class="margin-icon-profile"
                  />


                <span class=" d-none d-sm-none d-md-block d-lg-block d-xl-block"> Usuarios</span>
                <span class="titulo_menu d-block d-sm-block d-md-none d-lg-none d-xl-none"> Usuarios</span>


              </template>

      

              <users v-if="ifUsers"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


    


              </b-tab>

              <b-tab  @click="BuroLoad">

                  <template #title>
                    <feather-icon
                      icon="SearchIcon"
                      size="15"

                      class="margin-icon-profile"
                      />


                    <span class=" d-none d-sm-none d-md-block d-lg-block d-xl-block"> Consulta de buro</span>
                    <span class="titulo_menu d-block d-sm-block d-md-none d-lg-none d-xl-none"> Consulta de buro</span>


                  </template>

                  <b-card>

                  <buro v-if="ifBuro"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


                  </b-card>


                  </b-tab>


                  <b-tab  @click="TransaccionesLoad">

                <template #title>
                  <feather-icon
                    icon="ListIcon"
                    size="15"

                    class="margin-icon-profile"
                    />

                    <span class="titulo_menu" >Transacciones <count-transacciones :key="componentKeyCountTransacciones" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  />  </span>

        

                </template>

              

                <transacciones v-if="ifTransacciones"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


           

                </b-tab>

                <b-tab  @click="TutorialesLoad">

                <template #title>
                  <feather-icon
                  icon="YoutubeIcon"
                  size="15"

                  class="margin-icon-profile"
                  />

                  <span class=" d-none d-sm-none d-md-block d-lg-block d-xl-block">Videos tutoriales</span>
                  <span class="titulo_menu d-block d-sm-block d-md-none d-lg-none d-xl-none">Videos tutoriales</span>


                </template>

                <b-card>

                <tutoriales v-if="ifTutoriales" :key="componentKeyTutoriales"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


                </b-card>

                </b-tab>

                <b-tab  @click="SuscripcionesLoad">

                <template #title>
                  <feather-icon
                  icon="StarIcon"
                  size="15"

                  class="margin-icon-profile"
                  />
                  <span class="titulo_menu" >Publicaciones <count-publicaciones :key="componentKeyCountPublicaciones" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  />  </span>

          

                </template>

                <b-card>

                <marketplace v-if="ifSuscripciones" :key="componentKeySuscripciones"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


                </b-card>

                </b-tab>

                <b-tab  @click="NegociosLoad">

                  <template #title>
                    <feather-icon
                    icon="HomeIcon"
                    size="15"

                    class="margin-icon-profile"
                    />

                    <span class=" d-none d-sm-none d-md-block d-lg-block d-xl-block">Negocios</span>
                    <span class="titulo_menu d-block d-sm-block d-md-none d-lg-none d-xl-none">Negocios</span>


                  </template>

             

                  <negocios v-if="ifNegocios" :key="componentKeyNegociosAdmin"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />


                 

                  </b-tab>

                  <b-tab  @click="AdelantosLoad">

                  <template #title>
                    <feather-icon
                    icon="DollarSignIcon"
                    size="15"

                    class="margin-icon-profile"
                    />

                  
                    <span class="titulo_menu">Adelantos sueldos <count-adelantos :key="componentKeyCountAdelantos" :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin"  /> </span>


                  </template>


                  <b-card>
                    <adelantos v-if="ifAdelantos" :key="componentKeyAdelantosAdmin"  :user-id="userId" :token-auth="tokenAuth" :id-admin="idAdmin" />

                  </b-card>
               



                  </b-tab>



       </b-tabs>


    </b-row>


      
    


  
    </section>
  
  </template>
  
  <script>
  import { BRow, BCol,BSkeleton, BCard, BTabs, BTab, } from 'bootstrap-vue'
  import Retiros from './Retiros.vue'
  import Depositos from './Depositos.vue'
  import Paypal from './Paypal.vue'
  import Remesas from './Remesas.vue'
  import Wester from './Wester.vue'
  import Users from './Users.vue'
  import Buro from './Buro.vue'
  import Negocios from './Negocios.vue'
  import Tutoriales from './Tutoriales.vue'
  import Marketplace from './Marketplace.vue'
  import Transacciones from './Transacciones.vue'
  import Estadisticas from './Estadisticas.vue'
  import Adelantos from './Adelantos.vue'

  export default {
    components: {
      BRow,
      Adelantos,
      CountPublicaciones: () => import('./CountPublicaciones.vue'),
      CountTransacciones: () => import('./CountTransacciones.vue'),
      CountRetiros: () => import('./CountRetiros.vue'),
      CountAdelantos: () => import('./CountAdelantos.vue'),
      CountTransferencias: () => import('./CountTransferencias.vue'),
      CountWester: () => import('./CountWester.vue'),
      CountRemesas: () => import('./CountRemesas.vue'),
      CountPaypal: () => import('./CountPaypal.vue'),
      Negocios,
      BCol,
      Estadisticas,
      Tutoriales,
      Marketplace,
      Transacciones,
      Buro,
      Paypal,
      BCard,
      BTabs, BTab,
      BSkeleton,
      Retiros,
      Remesas,
      Depositos,
      Wester,
      Users
    },
    data() {


  
      const datos_json = JSON.parse(this.$userGlobal);
  
     
  
      return {
        componentKey: 900,
        activoPanel:0,
        componentKeyRetiros:1000,
        componentKeyCountRetiros:100,
        componentKeyCountRemesas:200,
        componentKeyEstadisticas:2000,
        componentKeyDepositos:3000,
        componentKeyPaypal:4000,
        componentKeyCountPaypal:300,
        componentKeyCountWester:400,
        componentKeyCountTransferencias:500,
        componentKeyCountTransacciones:600,
        componentKeyCountPublicaciones:700,
        componentKeyCountAdelantos:11000,
        componentKeyRecargas:5000,
        componentKeyRemesas:6000,
        componentKeyArchivosRemesas:7000,
        componentKeyTutoriales:8000,
        componentKeySuscripciones:9000,
        componentKeyNegociosAdmin:10000,
        componentKeyAdelantosAdmin:800,
        userId: datos_json.userId,
        tokenAuth: this.$tokenGlobal,
        loading:true,
        ifAdelantos:false,
        ifRetiros:false,
        ifNegocios:false,
        ifEstadisticas:true,
        ifDepositos:false,
        ifTutoriales:false,
        ifSuscripciones:false,
        ifPaypal:false,
        ifWester:false,
        ifUsers:false,
        ifTransacciones:false,
        ifBuro:false,
        ifRemesas:false,
        transactions:[],
        idAdmin:""
      }
    },
    watch:{
    $route (to, from){

      
  
      

      var hash = to.hash.substring(1); //Puts hash in variable, and removes the # character

 

      switch(hash) {

        case "estadisticas":
            this.activoPanel=0;
  
              this.ifEstadisticas=true;
            
              break;
            case "retiros":
            this.activoPanel=1;
  
              this.ifRetiros=true;
            
              break;
            case "remesas":
              
            this.activoPanel=2;
            this.ifRemesas=true;
              
            
              break;
              case "paypal":
              
              this.activoPanel=3;
              this.ifPaypal=true;
                
              
                break;
            case "red":  
              this.activoPanel=4;
              this.ifWester=true;
            
            
              break;
            case "depositos":  
            this.activoPanel=5;

              this.ifDepositos=true;
            
              break;

              case "usuarios":  
            this.activoPanel=6;

              this.ifUsers=true;
            
              break;

            case "buro":  
            this.activoPanel=7;
            this.ifBuro=true;
          
            
              break;

              case "transacciones":  
            this.activoPanel=8;
            this.ifTransacciones=true;
          
            
              break;

              case "tutoriales":  
            this.activoPanel=9;
            this.ifTutoriales=true;
          
            
              break;


              case "marketplace":  
            this.activoPanel=10;
            this.ifSuscripciones=true;
          
            
              break;

              case "negocios":  
            this.activoPanel=11;
            this.ifNegocios=true;
          
            
              break;

              case "adelantos":  
            this.activoPanel=12;
            this.ifAdelantos=true;
          
            
              break;
           
          
            default:
              this.activoPanel=0;
              this.ifEstadisticas=true;

              break;
        
          }
          
   
    }
},
    created() {
      // data
  
      /*
      this.$http.get('/analytics/data')
        .then(response => { this.data = response.data })
  
        */
    },
    activated() {

this.$eventBus.$emit('reiniciarMenu1')
 this.$eventBus.$emit('reiniciarMenu2')


},
    mounted() {

      let date1 = new Date().toLocaleString("es-ES", {timeZone: "America/Guayaquil",year: 'numeric',month: '2-digit',day: '2-digit'});

  

  
  
        this.$eventBus.$on('reiniciarArchivosRemesasAdmin', () => {
              this.componentKeyArchivosRemesas += 1
            })
      
  
      this.$eventBus.$on('reiniciarAdmin', () => {
        this.componentKey += 1
      });

      

      this.$eventBus.$on('reiniciarRemesasAdmin', () => {
        this.componentKeyRemesas += 1
      })
      
      this.$eventBus.$on('reiniciarRecargasAdmin', () => {
        this.componentKeyRecargas += 1
      })

      this.$eventBus.$on('reiniciarPaypalAdmin', () => {
        this.componentKeyPaypal += 1
      })

      this.$eventBus.$on('reiniciarCountPaypalAdmin', () => {
        this.componentKeyCountPaypal += 1
      })

      this.$eventBus.$on('reiniciarCountWesterAdmin', () => {
        this.componentKeyCountWester += 1
      })

      this.$eventBus.$on('reiniciarCountTransferenciasAdmin', () => {
        this.componentKeyCountTransferencias += 1
      })

      this.$eventBus.$on('reiniciarCountTransaccionesAdmin', () => {
        this.componentKeyCountTransacciones += 1
      })

      this.$eventBus.$on('reiniciarCountPublicacionesAdmin', () => {
        this.componentKeyCountPublicaciones += 1
      })

      this.$eventBus.$on('reiniciarCountAdelantosAdmin', () => {
        this.componentKeyCountAdelantos += 1
      })

      
      
      this.$eventBus.$on('reiniciarAdelantoAdmin', () => {
        this.componentKeyAdelantosAdmin += 1
      })
      
      
      this.$eventBus.$on('reiniciarNegociosAdmin', () => {
        this.componentKeyNegociosAdmin += 1
      })

      this.$eventBus.$on('reiniciarMarketplaceAdmin', () => {
        this.componentKeySuscripciones += 1
      })
      
      this.$eventBus.$on('reiniciarTutorialesAdmin', () => {
        this.componentKeyTutoriales += 1
      })

      this.$eventBus.$on('reiniciarDepositosAdmin', () => {
        this.componentKeyDepositos += 1
      })

      this.$eventBus.$on('reiniciarRetirosAdmin', () => {
        this.componentKeyRetiros += 1
      })

      this.$eventBus.$on('reiniciarCountRetirosAdmin', () => {
        this.componentKeyCountRetiros += 1
      })

      this.$eventBus.$on('reiniciarCountRemesasAdmin', () => {
        this.componentKeyCountRemesas += 1
      })
      

      this.$eventBus.$on('reiniciarEstadisticasAdmin', () => {
        this.componentKeyEstadisticas += 1
      })
      
  
      document.title = 'EQCoop - Administración';

      this.init();



  
    },
    methods: {
  
    init(){
    


    this.$https.post('/administracion/check/', { tokenAuth: this.tokenAuth, userId: this.userId }).then(response => {

   
        
      if (response.data.code == 200) {

        this.idAdmin= response.data["id"];
        
        this.loading = false;
          
 
        if(window.location.hash) {
          var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

  
     
          switch(hash) {
            case "estadisticas":
            this.activoPanel=0;
  
              this.ifEstadisticas=true;
            
              break;
            case "retiros":
            this.activoPanel=1;
  
              this.ifRetiros=true;
            
              break;
            case "remesas":
              
            this.activoPanel=2;
            this.ifRemesas=true;
              
            
              break;
              case "paypal":
              
              this.activoPanel=3;
              this.ifPaypal=true;
                
              
                break;
            case "red":  
              this.activoPanel=4;
              this.ifWester=true;
            
            
              break;
            case "depositos":  
            this.activoPanel=5;

              this.ifDepositos=true;
            
              break;

              case "usuarios":  
            this.activoPanel=6;

              this.ifUsers=true;
            
              break;

            case "buro":  
            this.activoPanel=7;
            this.ifBuro=true;
          
            
              break;

              case "transacciones":  
            this.activoPanel=8;
            this.ifTransacciones=true;
          
            
              break;

              case "tutoriales":  
            this.activoPanel=9;
            this.ifTutoriales=true;
          
            
              break;

              case "marketplace":  
            this.activoPanel=10;
            this.ifSuscripciones=true;
          
            
              break;

              case "negocios":  
            this.activoPanel=11;
            this.ifNegocios=true;
          
            
              break;

              case "adelantos":  
            this.activoPanel=12;
            this.ifAdelantos=true;
          
            
              break;
           
          
            default:
              this.activoPanel=0;
              this.ifEstadisticas=true;

              break;
            
              }
         
              }else{

                this.activoPanel=0;
                  this.ifEstadisticas=true;


            }
            

        
      } else {
        this.loading = false;

        if (response.data.code == 401) {
          
          localStorage.removeItem('userData')



          


          
          

          // Redirect to login page
          this.$router.push({ name: 'auth-login' })
        } else {

            if (response.data.code == 403) {

                this.$router.push({ name: 'dashboard-analytics' })

            }
          
        }
      }
    }).catch(error => {
         this.init();
    })
    },
    BuroLoad(){
      this.ifBuro = true
    },
    TransaccionesLoad(){
      this.ifTransacciones = true
    },
    UsersLoad(){
      this.ifUsers = true
    },
    WesterLoad(){
      this.ifWester = true
    },
    PaypalLoad(){
      this.ifPaypal = true
    },
    RemesasLoad(){
      this.ifRemesas = true
    },
    TutorialesLoad(){
      this.ifTutoriales = true
    },
    AdelantosLoad(){
      this.ifAdelantos = true
    },
    NegociosLoad(){
      this.ifNegocios = true
    },
    SuscripcionesLoad(){
      this.ifSuscripciones = true
    },
    DepositosLoad(){
      this.ifDepositos = true
    },
    RetirosLoad(){
      this.ifRetiros = true

    },

    EstadisticasLoad(){
      this.ifEstadisticas = true
    }

  
    },
  }
  </script>
  
  <style lang="scss" >

  
  </style>
  